export const hcExtra = {
  reservas: {
    buscar: "Suchen",
    limpiar: "Zurücksetzen",
    todas: "Alle",
  },
  nav: {
    volver: "Zurück",
  },
  listingDetail: {
    badgeNew: "Neu",
  },
  ofertas: {
    precio: "Preis",
  },
  payService: {
    sendRequest: "Anfrage senden",
  },
  accountCfg: {
    accountEmail: "Konto-E-Mail",
  },
};
